export enum CallingState {
  Calling = 'CALLING',
  Idle = 'IDLE',
  Acw = 'ACW',
  Detail = 'DETAIL',
  Visible = 'VISIBLE'
}
